<template>
    <Head title="Gyms" />

    <BreezeAuthenticatedLayout>
      <main class="container">
        <div class="py-12">

          <div class="c-header">
            <a href="" onclick="javascript:history.back(); return false;" class="c-header__back">
              <img src="/images/icons/icon-chevron-left.svg" alt="back">
            </a>
            <h2 class="c-header--h2">ボルダリングジム：編集</h2>
          </div>

          <div class="flex">

            <div class="mt-24">
              <form @submit.prevent="updateGym">
                <div>
                  <label for="title">ジム名称</label>
                  <div class="mt-1">
                    <input type="text" id="title" wire:model.lazy="title" name="title" v-model="form.title">
                  </div>
                </div>
                <div class="mt-24">
                  <label for="lead">紹介文</label>
                  <div class="mt-1">
                    <textarea id="lead" wire:model.lazy="lead" name="lead" v-model="form.lead"></textarea>
                  </div>
                </div>
                <div class="mt-24">
                  <label for="link_website">ウェブサイトURL</label>
                  <div class="mt-1">
                    <input type="url" id="link_website" wire:model.lazy="link_website" name="link_website" v-model="form.link_website" placeholder="https://" />
                  </div>
                </div>
                <div class="mt-24">
                  <label for="link_instagram">Instagram URL</label>
                  <div class="mt-1">
                    <input type="url" id="link_instagram" wire:model.lazy="link_instagram" name="link_instagram" v-model="form.link_instagram" placeholder="https://" />
                  </div>
                </div>
                <div class="mt-24">
                  <label for="link_twitter">Twitter URL</label>
                  <div class="mt-1">
                    <input type="url" id="link_twitter" wire:model.lazy="link_twitter" name="link_twitter" v-model="form.link_twitter" placeholder="https://" />
                  </div>
                </div>
                <div class="mt-24">
                  <label for="link_youtube">YouTube URL</label>
                  <div class="mt-1">
                    <input type="url" id="link_youtube" wire:model.lazy="link_youtube" name="link_youtube" v-model="form.link_youtube" placeholder="https://" />
                  </div>
                </div>

                <div class="mt-24">
                  <label for="title">画像</label>
                  <div>
                    <img :src="image" class="w-48 h-48">
                  </div>
                  <div class="mt-24">
                    <input type="file" id="image" wire:model="newImage" name="image" 
                    @input="form.image = $event.target.files[0]">
                  </div>
                </div>
                <div class="mt-24">
                  <button type="submit" class="c-button">更新する</button>
                </div>
              </form>
            </div>

          </div>

        </div>
        <Side />
      </main>
    </BreezeAuthenticatedLayout>
</template>

<script>
  import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
  import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
  import { Inertia } from '@inertiajs/inertia';
  import Side from '@/Shared/Side'

  export default {
    components: {
      BreezeAuthenticatedLayout,
      Head,
      Link,
      useForm,
      Inertia,
      Side,
    },

    setup(props) {
      const form = useForm({
        title: props.gym.title,
        lead: props.gym.lead,
        link_website: props.gym.link_website,
        link_instagram: props.gym.link_instagram,
        link_twitter: props.gym.link_twitter,
        link_youtube: props.gym.link_youtube,
        image: props.gym.image,
      });

      return { form };
    },

    props: {
      gym: Object,
      image: String
      // image:{
      //     type: String,
      // }
    },

    methods: {
      updateGym() {
        Inertia.post(`/gyms/${this.gym.id}`, {
        _method: 'put',
        title: this.form.title,
        lead: this.form.lead,
        link_website: this.form.link_website,
        link_instagram: this.form.link_instagram,
        link_twitter: this.form.link_twitter,
        link_youtube: this.form.link_youtube,
        image: this.form.image
      })
    },
    }
  }
</script>
